import axios from 'axios';

/**
 * Safe string for rendering SWR/API errors (never pass raw `unknown` into JSX).
 */
export function getUnknownErrorMessage(error: unknown, fallback: string): string {
  if (typeof error === 'string') return error;
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;
    if (typeof data === 'object' && data !== null) {
      const msg = (data as { message?: unknown }).message;
      if (typeof msg === 'string' && msg.trim()) return msg;
    }
    if (error.message) return error.message;
    return fallback;
  }
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}
